module.exports = __webpack_public_path__ + "media/images/athletes/3431-0cfca1eae54d4d1e505a9a07304cbbc4.png";